/**
 * en-GB messages added by Phase 1 task W6 (docs/PHASE-1-PLAN.md). Only that task edits this file.
 * Flat keys, `{name}` placeholders, merged into enGB by ./index.ts.
 */
export const w6EnGB = {
    // Templates list
    'badgeUi.title': 'Badge designs',
    'badgeUi.description': 'Label layouts for printed visitor badges.',
    'badgeUi.new': 'New design',
    'badgeUi.create.title': 'New badge design',
    'badgeUi.create.submit': 'Create design',
    'badgeUi.create.starterText': 'Visitor',
    'badgeUi.field.name': 'Name',
    'badgeUi.field.media': 'Label size',
    'badgeUi.field.site': 'Site',
    'badgeUi.field.orientation': 'Orientation',
    'badgeUi.site.all': 'All sites',
    'badgeUi.filter.active': 'Active',
    'badgeUi.filter.archived': 'Archived',
    'badgeUi.filter.all': 'All designs',
    'badgeUi.col.name': 'Name',
    'badgeUi.col.media': 'Label',
    'badgeUi.col.site': 'Site',
    'badgeUi.col.version': 'Version',
    'badgeUi.col.status': 'Status',
    'badgeUi.empty': 'No badge designs yet.',
    'badgeUi.archive': 'Archive',
    'badgeUi.restore': 'Restore',
    'badgeUi.version': 'v{version}',
    // Label sizes and orientation
    'badgeUi.media.dk11204_17x54': 'DK-11204, 17 x 54 mm (name only)',
    'badgeUi.media.dk11209_29x62': 'DK-11209, 29 x 62 mm',
    'badgeUi.media.dk11202_62x100': 'DK-11202, 62 x 100 mm (photo badge)',
    'badgeUi.media.dk22205_62x90': 'DK-22205, 62 mm continuous, cut at 90 mm',
    'badgeUi.orientation.landscape': 'Landscape',
    'badgeUi.orientation.portrait': 'Portrait',
    // Designer
    'badgeUi.designer.back': 'All badge designs',
    'badgeUi.designer.canvas': 'Label preview, {width} x {height} mm',
    'badgeUi.designer.canvasHelp': 'Select an element, then use the arrow keys to move it by 0.5 mm. Hold Shift to resize it. Press Delete to remove it.',
    'badgeUi.designer.palette': 'Add to label',
    'badgeUi.designer.properties': 'Element settings',
    'badgeUi.designer.noSelection': 'Select an element on the label to change it.',
    'badgeUi.designer.label': 'Label',
    'badgeUi.designer.readOnly': 'You can look at this design but not change it.',
    'badgeUi.position': '{name}: {x} mm across, {y} mm down, {w} by {h} mm',
    'badgeUi.warn.outside': 'Outside the printable area: {names}. Anything past the edge is cut off.',
    'badgeUi.save': 'Save as new version',
    'badgeUi.saved': 'Saved as version {version}.',
    'badgeUi.preview': 'Preview PDF',
    'badgeUi.preview.failed': 'The preview could not be made.',
    'badgeUi.discard': 'Discard changes',
    'badgeUi.remove': 'Remove element',
    'badgeUi.logo.upload': 'Upload design logo (PNG or JPEG)',
    'badgeUi.logo.uploaded': 'Logo uploaded.',
    // Element kinds
    'badgeUi.add.text_static': 'Fixed text',
    'badgeUi.add.text_data': 'Data text',
    'badgeUi.add.photo': 'Photo',
    'badgeUi.add.tenant_logo': 'Company logo',
    'badgeUi.add.site_logo': 'Site logo',
    'badgeUi.add.template_logo': 'Design logo',
    'badgeUi.add.qr': 'Sign-out QR code',
    'badgeUi.add.box': 'Box',
    'badgeUi.kind.text': 'Text',
    'badgeUi.kind.image': 'Image',
    'badgeUi.kind.qr': 'QR code',
    'badgeUi.kind.box': 'Box',
    'badgeUi.elementName': '{kind} {detail}',
    // Element settings
    'badgeUi.prop.x': 'Across (mm)',
    'badgeUi.prop.y': 'Down (mm)',
    'badgeUi.prop.w': 'Width (mm)',
    'badgeUi.prop.h': 'Height (mm)',
    'badgeUi.prop.sourceKind': 'Text comes from',
    'badgeUi.prop.sourceStatic': 'Fixed text',
    'badgeUi.prop.sourceData': 'Visit data',
    'badgeUi.prop.text': 'Text',
    'badgeUi.prop.dataKey': 'Data',
    'badgeUi.prop.fontSize': 'Font size (pt)',
    'badgeUi.prop.bold': 'Bold',
    'badgeUi.prop.align': 'Alignment',
    'badgeUi.prop.shrink': 'Shrink to fit',
    'badgeUi.prop.maxLines': 'Lines',
    'badgeUi.prop.image': 'Image',
    'badgeUi.prop.fit': 'Fit',
    'badgeUi.prop.stroke': 'Line width (mm)',
    'badgeUi.prop.fill': 'Filled',
    'badgeUi.align.left': 'Left',
    'badgeUi.align.center': 'Centre',
    'badgeUi.align.right': 'Right',
    'badgeUi.fit.contain': 'Whole image',
    'badgeUi.fit.cover': 'Fill the box',
    'badgeUi.image.photo': 'Visitor photo',
    'badgeUi.image.tenant_logo': 'Company logo',
    'badgeUi.image.site_logo': 'Site logo',
    'badgeUi.image.template_logo': 'Design logo',
    // Data keys
    'badgeUi.data.visitor_name': 'Visitor name',
    'badgeUi.data.first_name': 'First name',
    'badgeUi.data.group_name': 'Group',
    'badgeUi.data.site_name': 'Site name',
    'badgeUi.data.host_name': 'Host',
    'badgeUi.data.date': 'Date',
    'badgeUi.data.time_in': 'Time in',
    'badgeUi.data.tenant_name': 'Company name',
    'badgeUi.data.field': 'Field: {label}',
    'badgeUi.data.fieldStarred': 'Field: {label} (starred)',
    'badgeUi.data.fieldOther': 'Field not on this site',
    'badgeUi.sample.visitor_name': 'Alex Visitor',
    'badgeUi.sample.first_name': 'Alex',
    'badgeUi.sample.group_name': 'Visitors',
    'badgeUi.sample.site_name': 'Head office',
    'badgeUi.sample.host_name': 'Sam Host',
    'badgeUi.sample.date': '01/06/2026',
    'badgeUi.sample.time_in': '09:30',
    'badgeUi.sample.tenant_name': 'Example Ltd',
    'badgeUi.sample.field': 'Sample',
    // Settings cards
    'badgeUi.settings.defaultTemplate': 'Default badge design',
    'badgeUi.settings.noBadge': 'No badge at this site',
    'badgeUi.settings.mediaWarning': 'Warn when the loaded labels do not match the design',
    'badgeUi.settings.print': 'Print badges',
    'badgeUi.settings.print.never': 'Never',
    'badgeUi.settings.print.auto': 'Automatically at sign-in',
    'badgeUi.settings.print.ask': 'Ask the visitor',
    'badgeUi.settings.template': 'Badge design',
    'badgeUi.settings.siteDefault': 'The site default',
    'badgeUi.settings.manageLink': 'Open the badge designer',
};
//# sourceMappingURL=w6.js.map